import { Navigate } from 'react-router';

import { ANY_SPORT_LINEUPS_PRO } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const CareerLineupsRedirectPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_LINEUPS_PRO)} replace />
  );
};

export default CareerLineupsRedirectPage;
